"use strict";


Shopify.theme.jsSlideshowB2B = {
    init: function init($section) {
        // Add settings from schema to current object
        Shopify.theme.jsSlideshowB2B = $.extend(this, Shopify.theme.getSectionData($section));

        this.createSlider($section.attr('id'));
    },
    createSlider: function createSlider(id) {
        var mySwiper = new Swiper('.slideshow__container .swiper-container', {
            // Optional parameters
            loop: true,
            slidesPerView: 1.2,
            centeredSlides: false,
            grabCursor: true,
            spaceBetween: 0,
            navigation: {
                nextEl:  '#'+id+' .swiper-button.next',
                prevEl: '#'+id+' .swiper-button.previous',
            },
            breakpoints: {
                798: {
                    slidesPerView: 1,
                    centeredSlides: true,
                    spaceBetween: 40
                }
            }
        });
        mySwiper.init();
        mySwiper.snapGrid[mySwiper.snapGrid.length - 1] = mySwiper.slidesGrid[mySwiper.slidesGrid.length - 1];
        // var B2BSlider = $('.slideshow__container .image-slideshow-b2b');
        //
        // var blocks_limit = $(B2BSlider).find('.text-slide__heading').length;
        // console.log(blocks_limit);
        // var slideData = {
        //     blocks_per_slide: 1,
        //     wrapAround: true
        // };
        // $(B2BSlider).flickity({
        //     lazyLoad: 2,
        //     freeScroll: false,
        //     imagesLoaded: true,
        //     draggable: true,
        //     cellAlign: 'left',
        //     wrapAround: slideData.wrapAround,
        //     pageDots: false,
        //     contain: true,
        //     prevNextButtons: this.number_of_slides > 1,
        //     initialIndex: 0,
        //     arrowShape: arrowShape,
        //     on: {
        //         ready: function ready() {
        //             // Reset layout to avoid collapsing issues
        //             setTimeout(function () {
        //                 $(B2BSlider).flickity('resize');
        //             }, 500);
        //         }
        //     }
        //});
    },
    unload: function unload($section) {
        // var $slider = $section.find('.flickity-enabled');
        // $slider.flickity('destroy');
    }
};